import React, { Component, PropTypes } from 'react';
import shouldPureComponentUpdate from 'react-pure-render/function';

import Carousel from 'components/Carousel/Carousel';

import './Slideshow.scss';

export default class Slideshow extends Component {
  static propTypes = {
    images: PropTypes.object.isRequired,
    slideWidth: PropTypes.number,
    overlayText: PropTypes.string,
    toggleControlsAreActive: PropTypes.func.isRequired,
    mainImageType: PropTypes.string,
    thumbnailImageType: PropTypes.string,
    disableThumbnails: PropTypes.bool,
  };

  static defaultProps = {
    mainImageType: 'RGXL',
    thumbnailImageType: 'RTB',
    disableThumbnails: false,
  };

  state = {
    currentSlideIndex: 0,
  }

  shouldComponentUpdate = shouldPureComponentUpdate;


  get isFirstImage() {
    return this.state.currentSlideIndex === 0;
  }

  get isLastImage() {
    const images = this.props.images;
    const numOfImages = images.size;
    return this.state.currentSlideIndex === numOfImages - 1;
  }

  onClickNext = (event) => {
    const images = this.props.images;
    if (event) {
      event.preventDefault();
    }
    const numOfImages = images.size;
    this.setState({
      currentSlideIndex: (this.state.currentSlideIndex + numOfImages + 1) % numOfImages,
    });
  };

  onClickPrev = (event) => {
    const images = this.props.images;
    if (event) {
      event.preventDefault();
    }
    const numOfImages = images.size;
    this.setState({
      currentSlideIndex: (this.state.currentSlideIndex + numOfImages - 1) % numOfImages,
    });
  };

  onClickThumbnail = (event) => {
    /* istanbul ignore else  */
    if (event) {
      event.preventDefault();
      const newSlideIndex = Number(event.currentTarget.dataset.index);
      this.setState({
        currentSlideIndex: newSlideIndex,
      });
    }
  }

  render() {
    const { images, toggleControlsAreActive, slideWidth, overlayText, disableThumbnails } = this.props;
    const thumbsCarouselWidth = slideWidth;
    const showThumbnailControls = images.size > 1;

    return (
      <div className="slideshow">
        <div className="slideshow__main-image">
          <Carousel
            images={images}
            imageWidth={slideWidth}
            currentItemIndex={this.state.currentSlideIndex}
            onClickNext={this.onClickNext}
            onClickPrevious={this.onClickPrev}
            toggleControlsAreActive={toggleControlsAreActive}
            isFirstImage={this.isFirstImage}
            isLastImage={this.isLastImage}
            isSlideshow
            imageType={this.props.mainImageType}
          />
          { showThumbnailControls && (
            <div>
              <a href="#" className="slideshow__main-image__controller slideshow__main-image__controller--back" onClick={this.onClickPrev} />
              <a href="#" className="slideshow__main-image__controller slideshow__main-image__controller--next" onClick={this.onClickNext} />
            </div>
          )}
        </div>

        { showThumbnailControls && (
          <div className="slideshow__controller-container">
            <div className="slideshow__image-counter">{this.state.currentSlideIndex + 1}/{images.size}</div>
            { !disableThumbnails && (
              <Carousel
                images={images}
                imageWidth={70}
                viewWidth={thumbsCarouselWidth}
                currentItemIndex={this.state.currentSlideIndex}
                onClickNext={this.onClickNext}
                onClickPrevious={this.onClickPrev}
                onClickThumbnail={this.onClickThumbnail}
                toggleControlsAreActive={toggleControlsAreActive}
                isFirstImage={this.isFirstImage}
                isLastImage={this.isLastImage}
                isThumbnails
                imageType={this.props.thumbnailImageType}
              />
            ) }
          </div>
        )}

        { !!overlayText && (
          <div className="slideshow__overlay-text">{overlayText}</div>
        )}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Slideshow/Slideshow.jsx
 **/